import { render } from "./DuihuanRecord.vue?vue&type=template&id=c1f152c8&scoped=true"
import script from "./DuihuanRecord.vue?vue&type=script&lang=js"
export * from "./DuihuanRecord.vue?vue&type=script&lang=js"

import "./DuihuanRecord.vue?vue&type=style&index=0&id=c1f152c8&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f152c8"]])

export default __exports__